import React, { useState } from 'react';
import {createPortal} from 'react-dom'
import ConfirmationContext from './ConfirmationContext';
import ConfirmationModal from './ConfirmationModal';

function ConfirmationProvider({ children }) {

    const [modal, setModal] = useState(false);
    const [title, setTitle] = useState("Titel");
    const [text, setText] = useState("Text");
    const [confirmBtn, setConfirmBtn] = useState("Bestätigen");
    const [cancelBtn, setCancelBtn] = useState("Abbruch");
    const [confirmCallback, setConfirmCallback] = useState({ confirmCallback: (data) => { console.table(data); }});
    const closeCallback = () => setModal(false);

    const openModal = (title = "Titel", text = "Text", confirmCallback = () => { console.log("Confirm"); }, confirmBtn = "Bestätigen", cancelBtn = "Abbrechen") => {
        setTitle(title);
        setText(text);
        setConfirmBtn(confirmBtn);
        setCancelBtn(cancelBtn);
        setConfirmCallback({ confirmCallback });
        setModal(true);
    }

    const closeModal = () => { setModal(false); }

    const values = { openModal, closeModal };
    return <ConfirmationContext.Provider value={values}>
        {children}
        {createPortal(
            <ConfirmationModal title={title} text={text} cancelBtn={cancelBtn} confirmBtn={confirmBtn} confirmCallback={confirmCallback.confirmCallback} visible={modal} closeCallback={closeCallback}></ConfirmationModal>,
            document.body
        ) }
    </ConfirmationContext.Provider>
}

export default ConfirmationProvider;